/**
 * SoftPro API Service
 * Handles communication with SoftPro order creation API
 */

/**
 * Submit case data to SoftPro to create a new order
 * @param {Object} caseData - The case data from the form
 * @returns {Promise<Object>} Response from SoftPro API
 */
export const submitToSoftPro = async (caseData) => {
  try {
    const response = await fetch('/api/softpro/create-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(caseData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage = errorData.error || 'Failed to submit to SoftPro';
      const errorDetails = errorData.details ? `\n\nDetails: ${errorData.details}` : '';
      const statusInfo = errorData.status ? `\n\nHTTP Status: ${errorData.status}` : '';
      throw new Error(`${errorMessage}${statusInfo}${errorDetails}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting to SoftPro:', error);
    throw error;
  }
};
